import AXIOS from "./axios";

export class Council {
  static all() {
    return AXIOS.get("councils");
  }
}
